import Table from "../../../Components/Table/Table";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import TableLoading from "../../../Components/Loader/TableLoading";
import SVG from "../../../Components/SVG";

export default function FriendsTable({
  rows,
  accLoading,
  isLoadingMore,
}) {
  return (
    <div className="w-full flex flex-col gap-5">
      <div className="w-full">
        <Table
          isEnglish={[0, 3, 4, 5]}
          columns={[
            { key: "date", label: "تاریخ" },
            { key: "name", label: "نام" },
            { key: "challenge", label: "چالش" },
            { key: "challengePrice", label: "قیمت چالش" },
            { key: "commissionPercent", label: "درصد کمیسیون" },
            { key: "commissionAmount", label: "مبلغ کمیسیون" },
            {
              key: "status",
              label: "وضعیت",
              render: (value) =>
                value === "paid_out" ? (
                  <StatusColorful
                    SVGName="tick"
                    text="برداشت شده"
                    className="w-[100px]"
                    color="blue"
                  />
                ) : value === "pending" ? (
                  <StatusColorful
                    SVGName="stall"
                    text="در انتظار"
                    className="w-[100px]"
                    color="yellow"
                  />
                ) : value === "can_payout" ? (
                  <StatusColorful
                    SVGName="tick"
                    text="قابل برداشت"
                    className="w-[100px]"
                    color="green"
                  />
                ) : (
                  <StatusColorful
                    SVGName="stall"
                    text="نامشخص"
                    className="w-[100px]"
                    color="gray"
                  />
                ),
            },
          ]}
          data={rows}
        />
      </div>
      {accLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      {isLoadingMore && rows.length > 0 && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری بیشتر</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      {!accLoading && rows.length === 0 && (
        <div className="w-full flex justify-center items-center flex-col gap-5">
          <p className="text-zi-text-light dark:text-zi-text-dark text-sm sm:text-base">
            موردی برای نمایش وجود ندارد
          </p>
          <SVG name="noData" classname="w-24 fill-cyan-500" />
        </div>
      )}
    </div>
  );
}
